import select from './select/';
import request from './request/';
import page from './page/';
import price from './price';
import rate from './rate';

Vue.component('mp-request',function (resolve) {
  setTimeout(()=>resolve(request),0);
});
Vue.component('mp-select', select);
Vue.component('mp-page', page);
Vue.component('mp-rate', rate);
Vue.component('mp-price',function (resolve) {
  setTimeout(()=>resolve(price),0);
});




// WEBPACK FOOTER //
// ./src/components/list.js